<div nxModalContent>
    <h2>Are you sure you wish to continue?</h2>
    <p nxHeadline=" subsection-medium" class="nx-margin-bottom-2m">Any changes you have made will not be saved.</p>
</div>
<div nxModalActions>
    <button nxModalClose class="nx-margin-bottom-0 nx-margin-right-xs" (click)="openCloseModal(true)" nxButton="small"
        type="button">Continue</button>
    <button nxModalClose class="nx-margin-bottom-0" (click)="openCloseModal(false)" nxButton="small secondary"
        type="button">Cancel</button>
</div>